import { withHTMLComponent } from '@updater-legacy/components/custom-element';
import '@updater-components/fa-icon';
import styles from './index.css';

const tpl = `
  <div id="header">
    <slot name="title"></slot>
    <upd-fa-icon
      type="regular"
      name="angle-down"
    >
    </upd-fa-icon>
  </div>
  <slot></slot>
`;

const attrs = ['expanded'];
class ExpandableContainer extends withHTMLComponent(styles, tpl)() {
  static observedAttributes = attrs;
  static reflectedAttributes = attrs;
  static attributeTypes = {
    expanded: 'boolean',
  };

  _toggleExpanded = () => {
    this.expanded = !this.expanded;
  };

  /*
   * In IE 11 slots don't have a remove function for some reason.
   */
  hideContents() {
    if (this._slot.remove) {
      this._slot.remove();
    }
  }

  showContents() {
    if (this._slot.remove) {
      this.shadowRoot.insertBefore(this._slot, this._header);
    }
  }

  constructor() {
    super();
    this.icon = this.shadowRoot.querySelector('upd-fa-icon');
    this._slot = this.shadowRoot.querySelector('slot:not([name="title"])');
    this._header = this.shadowRoot.querySelector('div#header');
    this._title = this.shadowRoot.querySelector('slot[name="title"]');
    this.hideContents();
    this.shadowRoot
      .querySelector('#header')
      .addEventListener('click', this._toggleExpanded);
  }

  updated({ expanded }) {
    if (expanded) {
      this._title.assignedNodes()[0].innerHTML = 'See Less';
      this.icon.name = 'angle-up';
      this.classList.add('expanded');
      this.showContents();
    } else {
      this._title.assignedNodes()[0].innerHTML = 'See More';
      this.icon.name = 'angle-down';
      this.classList.remove('expanded');
      this.hideContents();
    }
  }
}

customElements.define('upd-features-expandable-container', ExpandableContainer);
